import env from '../.env.js';
import { ApisConfigure } from '../datasource/index';
import UserCtxInstance from '../store/userContext';

const apiConfigure = () => {
  const baseUrl = env.API_URL || `${window.location.protocol}//api.${window.location.hostname}`;
  const port = env.API_PORT !== '80' ? env.API_PORT : '';

  ApisConfigure.configureConsumer(baseUrl, port);

  ApisConfigure.axiosInstances().forEach((api) => {
    api.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response.status === 401) {
          UserCtxInstance.logout();
        }

        return Promise.reject(error);
      },
    );
  });
};

export default apiConfigure;
